var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import history, { expandPath } from '../history';
import { __RouterContext } from 'react-router';
import { Router } from 'react-router-dom';
function storeHistory(list) {
    window.sessionStorage.setItem('history-trace', JSON.stringify(list));
}
function readHistory() {
    return JSON.parse(window.sessionStorage.getItem('history-trace') || '[]');
}
function clearHistory() {
    window.sessionStorage.removeItem('history-trace');
}
function pushHistory(pathname) {
    var list = readHistory();
    storeHistory(__spreadArrays(list, [pathname]));
}
function popHistory() {
    var list = readHistory();
    storeHistory(list.slice(0, list.length - 1));
}
function lastElement(arr) {
    return arr[arr.length - 1];
}
// Delete the history if the user manually changed the path
window.addEventListener('load', function () {
    var list = readHistory();
    if (lastElement(list) !== history.location.pathname) {
        clearHistory();
    }
});
// tslint:disable-next-line: no-let
var direction = 'forward';
var getDirection = function (defaultHistory, currentPath) {
    var url = history.location.pathname;
    var sessionHistory = readHistory();
    // Populate the history trace if it does not exist
    if (sessionHistory.length === 0 && defaultHistory.length) {
        defaultHistory.forEach(function (path, i) {
            // Expand parameterized paths
            var expandedPath = expandPath(currentPath, url, path);
            if (i === 0) {
                history.replace(expandedPath);
            }
            else {
                history.push(expandedPath);
            }
        });
        history.push(url);
        storeHistory(defaultHistory);
        return direction;
    }
    // Back
    if (sessionHistory[sessionHistory.length - 2] === url) {
        direction = 'back';
        popHistory();
        return direction;
    }
    // Forward
    if (sessionHistory[sessionHistory.length - 1] !== url) {
        direction = 'forward';
        pushHistory(url);
        return direction;
    }
    return direction;
};
var goForward = function (path, opts) {
    var pathname = (opts === null || opts === void 0 ? void 0 : opts.replaceLast) ? history.location.pathname.replace(/\/[^/]+$/, '')
        : history.location.pathname;
    var pathStartsWithSlash = path[0] === '/';
    var pathnameEndsWithSlash = pathname.slice(-1) === '/';
    if (!pathStartsWithSlash && !pathnameEndsWithSlash) {
        // When the new path does _not_ start with a slash, we want the path to be
        // relative to the existing one (eg. appended). This only works in
        // react-router when the original path ends with a slash. So we fix that
        // here with an extra check.
        history.push({ pathname: pathname + "/" + path });
    }
    else {
        history.push({ pathname: path });
    }
};
var goBack = function () { return history.goBack(); };
var goForwardClick = function (path, opts) { return function () {
    return goForward(path, opts);
}; };
var goBackClick = function () { return function () { return goBack(); }; };
var RouterContext = React.createContext(undefined);
export function RouterProvider(props) {
    return (_jsx(Router, __assign({ history: history }, { children: _jsx(RouterContext.Provider, __assign({ value: {
                getDirection: getDirection,
                goForward: goForward,
                goBack: goBack,
                goForwardClick: goForwardClick,
                goBackClick: goBackClick,
            } }, props), void 0) }), void 0));
}
function usePageRouter() {
    var context = React.useContext(RouterContext);
    if (context === undefined) {
        throw new Error("usePageRouter must be used within a <RouterProvider />");
    }
    return context;
}
function useReactRouter() {
    var context = React.useContext(__RouterContext);
    if (context === undefined) {
        throw new Error("useReactRouter must be used within a <Router />");
    }
    return context;
}
export function useRouter() {
    var contextA = usePageRouter();
    var contextB = useReactRouter();
    return __assign(__assign({}, contextA), contextB);
}
//# sourceMappingURL=router-context.js.map